import { IRegulatoryResource } from 'state/regulatoryDocuments/regulatoryDocuments.model';
import { getQuoteRegulationInfos } from 'state/selectors';
import type { AppState } from 'state/state.model';
import type { WorkspaceType } from 'state/workspaces/model';
import { isQuoteWorkspaceType } from 'state/workspaces/model';

import type { RegulationDocument } from '../model';

export const getQuoteRegulationInfosSelector = (state: AppState, workspaceType: WorkspaceType, tabId: string) =>
  isQuoteWorkspaceType(workspaceType) ? getQuoteRegulationInfos(state, workspaceType, tabId) : undefined;

export function asDocuments(documents: IRegulatoryResource[]): RegulationDocument[] {
  const privateDocuments = documents.filter(d => d.isPublic === false && d.documentToken !== undefined);
  const publicDocuments = documents.filter(
    d => d.isPublic !== false && d.uri !== undefined && d.language !== undefined,
  );

  return publicDocuments.length > 0 ? publicDocuments : privateDocuments;
}
